import cn from 'classnames'
import React, { ComponentProps } from 'react'

type MccUtilitiesIconProps = {
  className?: string
} & ComponentProps<'svg'>

export default function MccUtilitiesIcon(props: MccUtilitiesIconProps) {
  const { className = '', ...rest } = props
  return (
    <svg
      className={cn('MccUtilitiesIcon', className)}
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M4.33331 14.6666H7.66665M7.99998 10.2175C9.57661 9.46852 10.6666 7.86152 10.6666 5.99992C10.6666 3.42259 8.57731 1.33325 5.99998 1.33325C3.42265 1.33325 1.33331 3.42259 1.33331 5.99992C1.33331 7.86152 2.42335 9.46852 3.99998 10.2175V10.6666C3.99998 11.2878 3.99998 11.5985 4.10147 11.8435C4.2368 12.1702 4.49636 12.4298 4.82307 12.5651C5.0681 12.6666 5.37872 12.6666 5.99998 12.6666C6.62124 12.6666 6.93186 12.6666 7.17689 12.5651C7.50359 12.4298 7.76316 12.1702 7.89849 11.8435C7.99998 11.5985 7.99998 11.2878 7.99998 10.6666V10.2175Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
